module.exports = __webpack_public_path__ + "img/3.bfc8aa12.png";